<template>
    <div class="push-meaasge-wrap">
        <bread-crumb :bread-list="breadList" />

        <div class="push-meaasge-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">push群发</span>
            </div>
            <div class="search-wrap">
                <div class="search-show-wrap">
                    <el-input class="search-input"
                              size="small"
                              placeholder="请输入push文案"
                              v-model="selectForm.text"
                              @keyup.enter.native="handleSearch">
                        <i slot="suffix"
                           class="iconfont icon-search"
                           @click="handleSearch"></i>
                    </el-input>
                </div>
                <el-button size="small"
                           @click="editDetail('add')">新增push</el-button>
            </div>
            <div class="table-wrap">
                <el-table :data="dataList"
                          v-loading="loading"
                          stripe
                          style="width: 100%">
                    <el-table-column prop="pushId"
                                     min-width="140px"
                                     label="模板编号">
                    </el-table-column>
                    <el-table-column width="120px"
                                     label="状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status !== 'WAIT'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已发送</span>
                            </div>
                            <div v-else
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">待发送</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="text"
                                     min-width="180px"
                                     label="push文案">
                    </el-table-column>
                    <el-table-column prop="url"
                                     min-width="180px"
                                     label="URL">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.url || '暂无' }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="type"
                                     min-width="100px"
                                     label="推送类型">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.type==='ALL'?'全员推送':'--' }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="peoples"
                                     min-width="80px"
                                     label="发送人数">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.peoples==='ALL'?'所有人':(scope.row.peoples||'暂无')}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="130px"
                                     label="推送时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.pushTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right"
                                     label="操作"
                                     width="160">
                        <template slot-scope="scope">
                            <span @click="editDetail('edit',scope.row)"
                                  v-if="isCanEdit(scope.row.pushTime,scope.row.status)"
                                  class="link-btn">编辑</span>
                            <span v-else class="link-btn link-btn-dis">编辑</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handlePageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { postPushList } from '@/api/pushMessage'
export default {
    name: 'pushMessage',
    data () {
        return {
            loading: false,
            breadList: [{ label: '运营管理' }, { label: 'push群发' }],
            selectForm: {
                text: ''
            },
            dataList: [],
            page: {
                current: 1,
                total: 0,
                pageSize: 10
            }
        }
    },
    mounted () {
        this.queryList()
    },
    methods: {
        // 只有push时间大于等于当前时间并且未发送的 才能点进去编辑
        isCanEdit (pushTime, status) {
            return ((new Date(pushTime).getTime() > new Date().getTime()) && status === 'WAIT')
        },
        handleSearch () {
            this.query(1)
        },
        query (val) {
            this.page.current = val
            this.queryList()
        },
        editDetail (type, item) {
            let pushId = ''
            if (type === 'edit') {
                pushId = item.pushId
            } else if (type === 'add') {
                pushId = 'add'
            }
            this.$router.push({
                name: 'pushMessageDetail',
                params: {
                    pushId: pushId
                }
            })
        },
        handlePageChange (val) {
            this.query(val)
        },
        async queryList () {
            let params = {
                text: this.selectForm.text,
                current: this.page.current,
                size: this.page.pageSize
            }
            this.loading = true
            this.dataList = []
            const { results, state } = await postPushList(params)
            if (results && state === 200) {
                this.page.total = results.total
                this.dataList = results.records
            }
            this.loading = false
        }
    },
    filters: {
        formatDate (value) {
            if (value) {
                return value.substring(0, 16)
            } else {
                return ''
            }
        }
    }
}
</script>
<style lang="scss">
.push-meaasge-wrap {
    height: 100%;
    .push-meaasge-content {
        height: calc(100% - 91px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            font-size: 0;
            padding-bottom: 20px;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }
        .search-wrap {
            padding-bottom: 20px;
            display: flex;
            justify-content: space-between;
            .search-show-wrap {
                display: flex;
            }
        }
        .status-warp {
            line-height: 12px;
            .el-badge {
                height: 10px;
                .el-badge__content {
                    width: 6px;
                    height: 6px;
                }
                .el-badge__content--success {
                    background: #4acfb1;
                }
                .el-badge__content--info {
                    background: #cccccc;
                }
            }
            .status_text {
                margin-left: 10px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #333333;
                line-height: 12px;
            }
        }

        .status-on {
            .icon-off {
                color: #ccc;
            }
            .icon-on {
                cursor: pointer;
                color: #3b8fd9;
            }
            .icon-paixuxia {
                font-size: 16px;
            }
            .icon-paixushang {
                font-size: 16px;
                margin-right: 20px;
            }
        }
        .status-off {
            .icon-paixuxia {
                font-size: 16px;
                color: #ccc;
            }
            .icon-paixushang {
                font-size: 16px;
                color: #ccc;
                margin-right: 20px;
            }
        }
        .link-btn {
            color: $a-link;
            cursor: pointer;
            font-size: 12px;
            display: inline-block;
            height: 14px;
            line-height: 14px;
            border-right: 1px solid $a-link;
            margin-right: 6px;
            padding-right: 6px;
            &:last-child {
                border-right: none;
                margin-right: 0;
                padding-right: 0;
            }
        }
        .link-btn-dis {
            color: $disable-link;
            cursor: not-allowed;
        }
    }
}
</style>
